// extracted by mini-css-extract-plugin
module.exports = {"stake":"Stake_stake__3ZnEF","heading":"Stake_heading__1-MCH","text":"Stake_text__dEbjs","stakeImg":"Stake_stakeImg__1Coa0","container":"Stake_container__10ctH"};